import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoiceQueryQueryVariables = Types.Exact<{
  invoiceNumber: Types.Scalars['String'];
}>;


export type InvoiceQueryQuery = { __typename?: 'QueryModel', invoices?: { __typename?: 'InvoicesQueryModel', invoice?: { __typename?: 'Invoice', invoiceNumber: string, projectNumber: number, state: Types.InvoiceState, invoiceDate?: string | null, notes?: string | null, taxRate: number, total: number, totalTax: number, projectName: string, customerName: string, customerNumber: string, corpLocationId: string, divisionId: string, officeCode: string, locationState: string, county: string, afe?: string | null, wo?: string | null, po?: string | null, costCenter?: string | null, pdfDownloadUrl: string, canRecall: boolean, canCancel: boolean, canEdit: boolean, canPostToRollup: boolean, taxDescription: string, lineItems?: Array<{ __typename?: 'InvoiceLineItem', invoiceNumber: string, projectChargeId: number, taxable: boolean, label: string, notes?: string | null, rate: number, quantity: number, billable: boolean, date: string, projectCharge?: { __typename?: 'ProjectCharge', id: number, projectId: number, date: string, quantity?: number | null, eeCode: string, unit?: Types.RateUnit | null, rate: number, total?: number | null, label: string, notes?: string | null, billable: boolean, type: Types.ChargeType, state: Types.ProjectChargeState, rateSheetName?: string | null, canMoveProject: boolean, canEditDate: boolean, canEditTaxable: boolean, employee?: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string } | null } | null, rebill?: { __typename?: 'LineItemRebillInfo', rebilledFromInvoice?: string | null, rebilledOnInvoice?: string | null } | null } | null> | null, billingAdmin?: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string } | null, project?: { __typename?: 'Project', number: number, internalNotes: string, customer?: { __typename?: 'Customer', nmTaxable: boolean, txTaxable: boolean } | null, projectGroup?: { __typename?: 'ProjectGroup', name: string } | null, location?: { __typename?: 'StateCounty', state: string, county: string } | null } | null, billedBy?: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string } | null, customRollupInvoice?: { __typename?: 'CustomRollupInvoice', invoiceNumber: string, state: Types.InvoiceState } | null } | null } | null };


export const InvoiceQueryDocument = gql`
    query InvoiceQuery($invoiceNumber: String!) {
  invoices {
    invoice(invoiceNumber: $invoiceNumber) {
      invoiceNumber
      projectNumber
      state
      invoiceDate
      notes
      taxRate
      total
      totalTax
      lineItems {
        invoiceNumber
        projectChargeId
        taxable
        projectCharge {
          id
          projectId
          date
          quantity
          eeCode
          unit
          rate
          total
          label
          notes
          billable
          type
          state
          rateSheetName
          employee {
            firstName
            middleInitial
            lastName
            userPrincipalName
          }
          canMoveProject
          canEditDate
          canEditTaxable
        }
        rebill {
          rebilledFromInvoice
          rebilledOnInvoice
        }
        label
        notes
        rate
        quantity
        billable
        date
      }
      projectName
      customerName
      customerNumber
      corpLocationId
      divisionId
      officeCode
      locationState
      county
      afe
      wo
      po
      costCenter
      billingAdmin {
        firstName
        middleInitial
        lastName
        userPrincipalName
      }
      project {
        number
        internalNotes
        customer {
          nmTaxable
          txTaxable
        }
        projectGroup {
          name
        }
        location {
          state
          county
        }
      }
      pdfDownloadUrl
      canRecall
      canCancel
      canEdit
      canPostToRollup
      billedBy {
        firstName
        middleInitial
        lastName
        userPrincipalName
      }
      taxDescription
      customRollupInvoice {
        invoiceNumber
        state
      }
    }
  }
}
    `;

/**
 * __useInvoiceQueryQuery__
 *
 * To run a query within a React component, call `useInvoiceQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQueryQuery({
 *   variables: {
 *      invoiceNumber: // value for 'invoiceNumber'
 *   },
 * });
 */
export function useInvoiceQueryQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQueryQuery, InvoiceQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceQueryQuery, InvoiceQueryQueryVariables>(InvoiceQueryDocument, options);
      }
export function useInvoiceQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQueryQuery, InvoiceQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceQueryQuery, InvoiceQueryQueryVariables>(InvoiceQueryDocument, options);
        }
export type InvoiceQueryQueryHookResult = ReturnType<typeof useInvoiceQueryQuery>;
export type InvoiceQueryLazyQueryHookResult = ReturnType<typeof useInvoiceQueryLazyQuery>;
export type InvoiceQueryQueryResult = Apollo.QueryResult<InvoiceQueryQuery, InvoiceQueryQueryVariables>;